"use client";
import { useEffect, useState } from "react";
import { Modal, Row, Col, Form } from "react-bootstrap";
import "./components.css";
import CommonButton from "./CommonButton";
import { TbX } from "react-icons/tb";
import { FaPlus } from "react-icons/fa";
import RateCardModal from "./RateCardModal";
import {
  createCustomPackage,
  updateCustomPackage,
  usersPerformance,
} from "@/services/pricing";
import { showToast } from "../../utils/libs/toast-utilis";
import { event } from "@/lib/analytics";

const roles = [
  "Fronted Developer",
  "Backend Developer",
  "UI Designer",
  "QA Engineer",
];
const seniorities = ["Junior", "Mid", "Senior"];

const DeveloperModal = ({
  show,
  onHide,
  checkRate,
  loadingTeamRole,
  roleOption,
  customTeamRole,
  fetchLeadDetails,
  quoteId,
}) => {
  const [teamRoles, setTeamRoles] = useState([
    { role: "", seniority: "", qty: 1 },
  ]);
  const [loadingBtn, setLoadingBtn] = useState(false);
  useEffect(() => {
    if (customTeamRole?.team_roles?.length > 0) {
      setTeamRoles(
        customTeamRole?.team_roles?.map((item) => ({
          role: item?.team_roles?.role_name,
          seniority: item?.team_roles?._id,
          qty: item?.quantity,
        }))
      );
    }
  }, [customTeamRole?.team_roles]);
  const handleAddRow = () => {
    if (
      roleOption?.map((item) => item?.options)?.flat()?.length ===
      teamRoles?.length
    ) {
      return;
    }
    setTeamRoles([...teamRoles, { role: "", seniority: "", qty: 1 }]);
  };

  const handleRemoveRow = (index) => {
    const updated = [...teamRoles];
    updated.splice(index, 1);
    setTeamRoles(updated);
  };

  const handleChange = (index, field, value) => {
    const updated = [...teamRoles];
    updated[index][field] = value;
    setTeamRoles(updated);
  };
  const selectedOptionIds = teamRoles?.map((tr) => tr.seniority);
  return (
    <>
      <Modal
        show={show}
        onHide={() => {
          onHide();
          setTeamRoles([{ role: "", seniority: "", qty: 1 }]);
        }}
        centered
        backdrop="static"
        keyboard={false}
        size="xl"
        className="team-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <h3 className="com-title" style={{ fontSize: "20px" }}>
              Create <span className="primary-color">custom</span> team role
            </h3>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="text-section mb-3 p-3 rounded bg-light">
            <Row className="gy-3">
              <Col md={9} className="align-self-center">
                <p className="mb-0 text-center text-md-start">
                  We have vast domains of{" "}
                  <span className="primary-color">experts!</span> Wanted to
                  check and <span className="primary-color">review</span> their{" "}
                  <span className="primary-color">rates?</span>
                </p>
              </Col>
              <Col md={3}>
                <CommonButton
                  label="Check Now!"
                  className="black-border d-block mx-auto ms-md-auto mx-md-0"
                  variant="outline"
                  disabled={loadingTeamRole}
                  onClick={checkRate}
                />
              </Col>
            </Row>
          </div>
          <div
            style={{
              maxHeight: "500px",
              overflowY: "auto",
              overflowX: "hidden",
            }}
          >
            {teamRoles.map((item, index) => (
              <Row
                key={index}
                className="align-items-center mb-3 team-selection gy-2 border-bottom pb-3"
              >
                <Col lg={6} md={5} sm={12} xs={12}>
                  <Form.Select
                    value={item.role}
                    onChange={(e) => {
                      handleChange(index, "role", e.target.value);
                      const findSeniority = roleOption
                        ?.find((val) => val?.role_name === e.target.value)
                        ?.options?.filter(
                          (val) =>
                            !selectedOptionIds.includes(val?._id) ||
                            val?._id === item.seniority
                        )
                        .find((item) => item?.experience_levels === "junior");
                      handleChange(index, "seniority", findSeniority?._id);
                    }}
                  >
                    <option value="">Select Developer</option>
                    {roleOption
                      ?.filter((role) =>
                        role?.options?.some(
                          (opt) =>
                            !selectedOptionIds.includes(opt._id) ||
                            item.seniority === opt._id
                        )
                      )
                      ?.map((r, i) => (
                        <option key={i} value={r?.role_name}>
                          {r?.role_name}
                        </option>
                      ))}
                  </Form.Select>
                </Col>
                <Col lg={3} md={3} sm={5} xs={5}>
                  <Form.Select
                    value={item.seniority}
                    disabled={!(item.role?.length > 0)}
                    onChange={(e) =>
                      handleChange(index, "seniority", e.target.value)
                    }
                  >
                    <option value="">Select Seniority</option>
                    {roleOption?.length > 0 &&
                      roleOption
                        ?.find((val) => val?.role_name === item.role)
                        ?.options?.filter(
                          (val) =>
                            !selectedOptionIds.includes(val?._id) ||
                            val?._id === item.seniority
                        )
                        ?.map((r, index) => (
                          <option key={index} value={r?._id}>
                            {r?.experience_levels}
                          </option>
                        ))}
                  </Form.Select>
                </Col>
                <Col lg={1} md={2} sm={4} xs={4}>
                  <Form.Select
                    value={item.qty}
                    onChange={(e) => handleChange(index, "qty", e.target.value)}
                  >
                    {[...Array(10)].map((_, i) => (
                      <option key={i + 1}>{i + 1}</option>
                    ))}
                  </Form.Select>
                </Col>
                <Col lg={2} md={2} sm={3} xs={3}>
                  <div className="d-flex gap-2">
                    {index === teamRoles.length - 1 && (
                      <div
                        className={`primary-div ${
                          roleOption?.map((opt) => opt?.options)?.flat()
                            ?.length === teamRoles?.length
                            ? "add-team-disabled"
                            : ""
                        }`}
                        onClick={handleAddRow}
                        style={{ cursor: "pointer" }}
                      >
                        <FaPlus size={16} />
                      </div>
                    )}
                    {/* {teamRoles.length > 1 && ( */}
                    <div
                      className="outline-div"
                      onClick={() => handleRemoveRow(index)}
                      style={{ cursor: "pointer" }}
                    >
                      <TbX size={16} />
                    </div>
                    {/* )} */}
                  </div>
                </Col>
              </Row>
            ))}
          </div>
          {!(teamRoles?.length > 0) && (
            <div
              className="d-flex justify-content-center gap-3 add-team-member"
              onClick={handleAddRow}
            >
              <p className="p-0 m-0">+ Add Team Member</p>
            </div>
          )}
          <div className="d-flex justify-content-center gap-3 mt-4">
            <CommonButton
              label="Cancel"
              className="black-border"
              variant="outline"
              onClick={onHide}
            />
            {(customTeamRole?.team_roles?.length > 0 ||
              teamRoles?.length > 0) && (
              <CommonButton
                label={
                  customTeamRole?.team_roles?.length > 0
                    ? "Update Team"
                    : "Add Team"
                }
                className="btn-primary"
                onClick={async () => {
                  setLoadingBtn(true);
                  if (customTeamRole?.team_roles?.length > 0) {
                    const res = await updateCustomPackage(
                      {
                        team_roles: teamRoles?.map((item) => ({
                          quantity: item?.qty,
                          team_roles: item?.seniority,
                        })),
                      },
                      customTeamRole?._id
                    );
                    if (res?.pkg?._id) {
                      showToast.success(
                        "🎉 Done! Your custom team role has been updated."
                      );
                      fetchLeadDetails();
                      onHide();
                    }
                    event({
                      action: "added custom team",
                      params: {
                        page: "project_price_page",
                        ...res,
                      },
                    });
                  } else {
                    const res = await createCustomPackage({
                      team_roles: teamRoles?.map((item) => ({
                        quantity: item?.qty,
                        team_roles: item?.seniority,
                      })),
                    });
                    if (res?.pkg?._id) {
                      showToast.success(
                        "🎉 Done! Your custom team role has been created."
                      );
                      fetchLeadDetails();
                      onHide();
                      // await usersPerformance({
                      //   payload: {
                      //     customStatus: "Interested",
                      //     packageId: [res?.pkg?._id],
                      //   },
                      //   leadId: quoteId,
                      // });
                    }
                    event({
                      action: "updated custom team",
                      params: {
                        page: "project_price_page",
                        ...res,
                      },
                    });
                  }
                  setLoadingBtn(false);
                }}
                disabled={
                  loadingBtn ||
                  !teamRoles?.every(
                    (item) =>
                      item?.qty > 0 &&
                      item?.seniority?.length > 0 &&
                      item?.role?.length > 0
                  )
                }
              />
            )}
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default DeveloperModal;
